import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiQuizService } from './fi-quiz.service';
import { FiQuizHelperService } from './fi-quiz-helper.service';
import { FiQuizListModule } from './fi-quiz-list/fi-quiz-list.module';
import { FiQuizEditModule } from './fi-quiz-edit/fi-quiz-edit.module';
import { UIRouterModule } from '@uirouter/angular';
import { QuizStates } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-states';
import { FiQuizActionsBuilderService } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-actions-builder.service';
import { FiQuizViewModule } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz-view/fi-quiz-view.module';

@NgModule({
    imports: [CommonModule, UIRouterModule.forChild(QuizStates), FiQuizListModule, FiQuizEditModule, FiQuizViewModule],
    declarations: [],
    providers: [FiQuizService, FiQuizHelperService, FiQuizActionsBuilderService],
})
export class FiQuizModule {}
